export default __webpack_public_path__ + "d2d97a9feca22f12a8c8c7413d7867ac.jpg";